
































































import { Vue, Component, Prop } from "vue-property-decorator";
import { LMap, LTileLayer, LMarker, LIcon, LCircleMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Pothole } from "../datatypes";
import {
  collection,
  CollectionReference,
  doc,
  DocumentReference,
  Firestore,
  DocumentSnapshot,
  onSnapshot,
} from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { app } from "../firebaseConfig";

const db: Firestore = getFirestore(app);
const potholeCollection: CollectionReference = collection(db, "potholes");
const allReportsDoc: DocumentReference = doc(potholeCollection, "allReports");

@Component({ components: { LMap, LTileLayer, LMarker, LIcon, LCircleMarker } })
export default class DisplayMap extends Vue {
  @Prop() mapCenter!: Array<number>;

  geoPos: { lat?: number; lng?: number } = {};
  displayPotholeArr: Array<Pothole> = [];
  heatmapMode = true;
  mapUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  mapAttribution =
    "&copy; <a target='_blank' href='http://osm.org/copyright'>OpenStreetMap</a>";
  canEditMap = false;
  coneIcon = "https://ik.imagekit.io/carharv/coneIcon";

  mounted() {
    this.getPotholes();
  }

  //This function listens for updates
  getPotholes(): void {
    onSnapshot(allReportsDoc, (reports: DocumentSnapshot) => {
      if (reports.exists()) {
        this.displayPotholeArr = reports.data().potholeArray;
        console.log("Pothole Array has been updated");
      }
    });
  }
}
